import { Icon, useGoodlokIsAdmin } from '@goodlok/react-sdk'
import { notify } from '@goodlok/ui'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import clsx from 'clsx'
import { Dispatch, FunctionComponent, SetStateAction, useState } from 'react'
import { thunder } from '../app/data/thunder'
import styles from './AdminAdjustShiftSlots.module.sass'

type AdminAdjustShiftSlotsProps = {
	slotsTaken: number
	slotsTotalState: number
	exit: Dispatch<SetStateAction<boolean>>
	shiftGroupId?: string
	setSlotsTotalState: Dispatch<SetStateAction<number>>
}

export const AdminAdjustShiftSlots: FunctionComponent<AdminAdjustShiftSlotsProps> = ({
	slotsTaken,
	slotsTotalState,
	exit,
	shiftGroupId,
	setSlotsTotalState,
}) => {
	const [disappear, setDisappear] = useState(false)

	const isAdmin = useGoodlokIsAdmin()

	const queryClient = useQueryClient()
	const deleteShiftGroupMutation = useMutation(
		async () => {
			return thunder.admin('mutation')({
				deleteTimetableShiftGroup: [{ by: { id: shiftGroupId } }, { ok: true, errorMessage: true }],
			})
		},
		{
			onSuccess: (data) => {
				if (!data.deleteTimetableShiftGroup.ok) {
					notify('Nepodařilo se smazat skupinu směn', 'error')
					console.error(data.deleteTimetableShiftGroup.errorMessage)
					return
				}
				notify('Skupina směn smazána', 'success')
				queryClient.invalidateQueries(['adminPageData'])
			},
		}
	)

	return (
		<div className={clsx(styles.wrapper, disappear && styles.disappear)}>
			<div className={styles.control}>
				<button
					type="button"
					className={styles.minus}
					onClick={async () => {
						if (slotsTaken === slotsTotalState) {
							return
						}
						setSlotsTotalState(slotsTotalState - 1)
						// @TODO rewrite to mutation
						await fetch('/api/remove-shift-slot', {
							method: 'POST',
							body: JSON.stringify({
								shiftGroupId: shiftGroupId,
							}),
						})
					}}>
					<Icon name={'minus'} />
				</button>
				<div className={styles.slots}>
					{slotsTaken} | {slotsTotalState}
				</div>
				<button
					type="button"
					className={styles.plus}
					onClick={async () => {
						setSlotsTotalState(slotsTotalState + 1)
						// @TODO rewrite to mutation
						await fetch('/api/add-shift-slot', {
							method: 'POST',
							body: JSON.stringify({
								shiftGroupId: shiftGroupId,
							}),
						})
					}}>
					<Icon name={'plus'} />
				</button>
			</div>
			<button
				type="button"
				className={clsx(styles.ok, disappear && styles.disappear)}
				onClick={() => {
					setDisappear(true)
				}}
				onAnimationEnd={() => {
					setDisappear(false)
					exit(false)
				}}>
				ok
			</button>
			{isAdmin && (
				<button
					className={styles.remove}
					type="button"
					onClick={() => {
						deleteShiftGroupMutation.mutate()
					}}>
					<Icon name="trash" />
				</button>
			)}
		</div>
	)
}
